import React from "react";
import StarIcon from "./Icons/Star";
import HalfStarIcon from "./Icons/HalfStar";
import styled, { css } from "styled-components";
import StarSmallIcon from "./Icons/StarSmall";
import HalfStarSmallIcon from "./Icons/HalfStarSmall";

const StarStyles = styled.div`
  ${({ ...props }) => css`
    margin-bottom: 8px;
    svg {
      margin-right: 4px;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      margin: 0 16px 0 0;
    }
  `}
`;

export const Stars = ({ aR, small }) => {
  let stars;
  let fullStar = <StarIcon />;
  let halfStar = <HalfStarIcon />;

  if (small) {
    fullStar = <StarSmallIcon />;
    halfStar = <HalfStarSmallIcon />;
  }

  if (aR >= 0 && aR <= 0.99) {
    stars = <>{halfStar}</>;
  } else if (aR >= 1 && aR <= 1.49) {
    stars = <>{fullStar}</>;
  } else if (aR >= 1.5 && aR <= 1.99) {
    stars = (
      <>
        {fullStar}
        {halfStar}
      </>
    );
  } else if (aR >= 2 && aR <= 2.49) {
    stars = (
      <>
        {fullStar}
        {fullStar}
      </>
    );
  } else if (aR >= 2.5 && aR <= 2.99) {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {halfStar}
      </>
    );
  } else if (aR >= 3 && aR <= 3.49) {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {fullStar}
      </>
    );
  } else if (aR >= 3.5 && aR <= 3.99) {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {fullStar}
        {halfStar}
      </>
    );
  } else if (aR >= 4 && aR <= 4.49) {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {fullStar}
        {fullStar}
      </>
    );
  } else if (aR >= 4.5 && aR <= 4.99) {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {fullStar}
        {fullStar}
        {halfStar}
      </>
    );
  } else {
    stars = (
      <>
        {fullStar}
        {fullStar}
        {fullStar}
        {fullStar}
        {fullStar}
      </>
    );
  }

  return <StarStyles>{stars}</StarStyles>;
};
